import React from 'react';
import { DepositFrequency } from './AddGoalDepositFlow';
import { Icon } from '../Icon';
import './DepositFrequencySelector.css';

interface DepositFrequencySelectorProps {
  value?: DepositFrequency;
  onChange: (frequency: DepositFrequency) => void;
  onBack: () => void;
}

export const DepositFrequencySelector: React.FC<DepositFrequencySelectorProps> = ({
  value,
  onChange,
  onBack
}) => {
  const options: Array<{ value: DepositFrequency; icon: string; title: string; description: string }> = [
    { value: 'daily', icon: 'sun', title: 'Ежедневно', description: 'Каждый день' },
    { value: 'weekly', icon: 'repeat', title: 'Еженедельно', description: 'Раз в неделю' },
    { value: 'monthly', icon: 'calendar', title: 'Ежемесячно', description: 'Раз в месяц' },
    { value: 'yearly', icon: 'calendar', title: 'Ежегодно', description: 'Раз в год' },
  ];

  return (
    <div className="deposit-frequency-selector step-content">
      <div className="deposit-frequency-selector__header">
        <button className="deposit-frequency-selector__back" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="deposit-frequency-selector__header-content">
          <h2 className="deposit-frequency-selector__title">Частота пополнения</h2>
          <p className="deposit-frequency-selector__subtitle">
            Как часто пополнять цель?
          </p>
        </div>
      </div>

      <div className="deposit-frequency-selector__options">
        {options.map((option) => (
          <button
            key={option.value}
            className={`deposit-frequency-option ${value === option.value ? 'deposit-frequency-option--active' : ''}`}
            onClick={() => onChange(option.value)}
          >
            <div className="deposit-frequency-option__icon">
              <Icon name={option.icon} size={28} color={value === option.value ? 'var(--color-primary)' : 'var(--color-text-secondary)'} />
            </div>
            <div className="deposit-frequency-option__content">
              <div className="deposit-frequency-option__title">{option.title}</div>
              <div className="deposit-frequency-option__description">{option.description}</div>
            </div>
            <div className="deposit-frequency-option__check">
              {value === option.value && <Icon name="check" size={20} color="var(--color-primary)" />}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

